// extracted by mini-css-extract-plugin
module.exports = {"page":"PageList_page__3dezu"};